import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { lazy } from "react";

// Define lazy-loaded components
const Ocr = lazy(() => import("../pages/Ocr"));

const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard"));
const EmployeeDirectory = lazy(() =>
  import("../pages/EmployeeDirectory/EmployeeDirectory")
);
const CreateEmployee = lazy(() =>
  import("../pages/CreateEmployee/CreateEmployee")
);
const MeetingCalendar = lazy(() =>
  import("../pages/MeetingCalendarAll/MeetingCalendarAll")
);
const CreateMeetingCalendar = lazy(() =>
  import("../pages/CreateMeetingCalendar/CreateMeetingCalendar")
);
const MeetingDetails = lazy(() =>
  import("../pages/MeetingDetails/MeetingDetails")
);
const UserProfile = lazy(() => import("../pages/UserProfile/UserProfile"));
const TaskDashboard = lazy(() =>
  import("../pages/TaskDashboard/TaskDashboard")
);
const CreateTask = lazy(() => import("../pages/CreateTask/CreateTask"));
const TaskDetail = lazy(() => import("../pages/TaskDetail/TaskDetail"));
const MyTask = lazy(() => import("../pages/MyTask/MyTask"));
const ViewSmartAttendance = lazy(() =>
  import("../pages/ViewSmartAttendance/ViewSmartAttendance")
);
const SharedFolder = lazy(() => import("../pages/SharedFolder/SharedFolder"));
const NewSharedFolder = lazy(() =>
  import("../pages/NewSharedFolder/NewSharedFolder")
);
const SharePublicView = lazy(() =>
  import("../pages/SharePublicView/SharePublicView")
);
const SharePrivateView = lazy(() =>
  import("../pages/SharePrivateView/SharePrivateView")
);
const SmartDocument = lazy(() => import("../pages/SmartDocument"));
const NewLinksAndVides = lazy(() =>
  import("../pages/NewLinksAndVideos/NewLinksAndVideos")
);
const LinksAndVideos = lazy(() =>
  import("../pages/LinksAndVideos/LinksAndVideos")
);
const NewDocument = lazy(() => import("../pages/NewDocument"));
const ViewDocument = lazy(() => import("../pages/ViewDocument"));
const SignDocument = lazy(() => import("../pages/SignDocument"));
const ReviewedDocument = lazy(() => import("../pages/ReviewedDoc"));
const MOM = lazy(() => import("../pages/MOM"));
const Request = lazy(() => import("../pages/Request"));
const ViewRequest = lazy(() => import("../pages/ViewRequest"));
const ForgotClockinOut = lazy(() =>
  import("../pages/ForgotClockin&out/index.js")
);
const ViewReqbyId = lazy(() => import("../pages/ViewReqbyID"));
const TimeZoneChange = lazy(() => import("../pages/TimeZone/index.js"));
const Debugger = lazy(() => import("../components/Debugger.js"));
const AddMom = lazy(() => import("../pages/AddMom"));
const CreateMom = lazy(() => import("../pages/CreateMom"));
const ViewMom = lazy(() => import("../pages/ViewMom"));
const WorkFlow = lazy(() => import("../pages/CreateWorkFlow"));
const AINote = lazy(() => import("../pages/AINote/AINote"));
const QuickAll = lazy(() => import("../components/QuickAll"));
const Assets = lazy(() => import("../pages/Assets/Assets"));
const viewassets = lazy(()=>import("../pages/ViewAssets"))
const NewAsset = lazy(() => import("../pages/NewAsset/NewAsset"));
const Group = lazy(() => import("../pages/Group/Group"));
const ViewGroup = lazy(() => import("../pages/ViewGroup/ViewGroup"));
const ViewTeam = lazy(() => import("../pages/ViewTeam/index.js"));
const EditTeam = lazy(() =>import("../pages/EditTeam"))
const NewGroup = lazy(() => import("../pages/NewGroup/NewGroup"));
const SmartServiceDashboard = lazy(() =>
  import("../pages/SmartServiceDashboard/SmartServiceDashboard.js")
);
const LeaveRequest = lazy(() => import("../pages/LeaveRequest/LeaveRequest"));
const SickLeave = lazy(() => import("../pages/SickLeave/SickLeave"));
const WorkHomeRequest = lazy(() =>
  import("../pages/WorkHomeRequest/WorkHomeRequest")
);
const ViewSmartService = lazy(() =>
  import("../pages/ViewSmartService/ViewSmartService")
);
const ProjectDashboard = lazy(() =>
  import("../pages/ProjectDashboard/ProjectDashboard")
);
const CreateProject = lazy(() =>
  import("../pages/CreateProject/CreateProject")
);
const AllProject = lazy(() => import("../pages/AllProject/AllProject"));
const ViewProject = lazy(() => import("../pages/ViewProject/ViewProject"));
const AllProjectTask = lazy(() =>
  import("../pages/AllProjectTask/AllProjectTask")
);
const CeoDashboard = lazy(() => import("../pages/CeoDashboard/CeoDashboard"));
const OverAllInProgressTask = lazy(() =>
  import("../pages/OverAllInProgressTask/OverAllInProgressTask")
);
const OverAllInProgressProject = lazy(() =>
  import("../pages/OverAllInProgressProject/OverAllInProgressProject")
);
const CeoUserlist = lazy(() => import("../pages/CeoUserlist/CeoUserlist"));
const CeoEmployees = lazy(() => import("../pages/CeoEmployees/CeoEmployes"));
const AiDocumentEngine = lazy(() =>
  import("../pages/AiDocumentEngine/AiDocumentEngine")
);
const PdfDocument = lazy(() => import("../pages/PdfDocument"));
const PdfMom = lazy(() => import("../pages/PdfMom"));
const SignMom = lazy(() => import("../pages/SignMom"));
const ReviewMom = lazy(() => import("../pages/ReviewMom"));
const ViewpdfMom = lazy(() => import("../pages/ViewpdfMom/ViewpdfMom"));
const ViewPdf = lazy(() => import("../pages/ViewPdf/ViewPdf"));
const ITSupportManager = lazy(() =>
  import("../pages/ITSupportManager/ITsupport")
);
const ItSupportView = lazy(() =>
  import("../pages/ItSupportView/ItSupportView")
);

const AssignItTickets = lazy(() =>
  import("../pages/AssignItTickets/AssignItTickets")
);
const ViewTickets = lazy(() => import("../pages/ViewTickets/index"));
const ITsupportemployee = lazy(() => import("../pages/ITsupportemployee"));
const AddTickets_E = lazy(() => import("../pages/AddTickets"));
const CeoAttendance = lazy(() => import("../pages/CeoAttendance"));
const CeoRequest = lazy(() => import("../pages/CeoRequest"));
// const CeoViewsmart = lazy(()=>import("../pages/viewceosmartservice"))
const CeoMeetings = lazy(() => import("../pages/CeoMeetings"));
const CeoTasks = lazy(() => import("../pages/CeoTask"));
const ViewCeoTasks = lazy(() => import("../pages/ViewCeoTask"));
const CeoDocuments = lazy(() => import("../pages/CeoDocuments"));
const AttendanceReport = lazy(() => import("../pages/AttendanceReport"));
const EditMeeting = lazy(() => import("../pages/EditMeeting"));
const EditProjects = lazy(() => import("../pages/EditProjects"));
const EditTask = lazy(() => import("../pages/EditTask"));
const PayrollDashboard = lazy(() => import("../pages/PayrollDashboard"));
const PayrollDetails = lazy(() => import("../pages/PayrollDetails"));
const userprofileDetails = lazy(()=> import("../pages/UserProfileDetails"))

const Notification = lazy(() =>
  import("../pages/Notification/Notification.js")
);

const ChangePassword = lazy(() => import("../pages/Changepassword/index.js"));

const ChatBot = lazy(() => import("../pages/ChatBot/index.js"));
// const Chat = lazy(() => import("../pages/Chat/index.js"));
// const NewChat = lazy(() => import("../pages/NewChat/index.js"));
// const ChatPage = lazy(() => import("../pages/ChatPage/index.js"));
const Bot = lazy(() => import("../pages/Bot"));
const BotHistory = lazy(() => import("../pages/BotHistory"));
const ProjectMeeting = lazy(() => import("../pages/ProjectMeeting/ProjectMeeting.js"));
const ProjectTask = lazy(() => import("../pages/ProjectTask/ProjectTask.js"));
const ProjectSmartDocument = lazy(() => import("../pages/ProjectSmartDocument/ProjectSmartDocument.js"));
const Holiday = lazy(() => import("../pages/Holiday/Holiday.js"));
const AddHoliday = lazy(() => import("../pages/AddHoliday/AddHoliday.js"));
const ViewHoliday = lazy(() => import("../pages/ViewHoliday/ViewHoliday.js"));
const Announcement = lazy(() => import("../pages/Announcement"));
const announcementdetail = lazy(() => import("../pages/AnnouncementDetails"));
const AddAnnouncement = lazy(() => import("../pages/AddAnnouncement"));
const EditEmployees = lazy(() => import("../pages/EditEmployees"));
const EditLeaveRequest = lazy(() => import("../pages/EditLeaveRequest"));
const EditWFRRequest = lazy(() => import("../pages/EditWFHRequest"));
const EmployeeDetails = lazy(()=> import("../pages/EmployeeDetails/index.js"))

const AiPdfGenerator  = lazy(() => import("../pages/AiPdfGenerator/AiPdfGenerator.js"));
const ChartingAndDiagramming = lazy(() => import("../pages/ChartingAndDiagramming/index.js"));


// Define core routes
const coreRoutes = [
  {
    path: "/home",
    component: Dashboard,
    name:'home'
  },
  {
    path:'/home/chartgenerator',
    component: ChartingAndDiagramming,
    name:"chartingAndDiagramming"
  },
  {
    path : "/home/announcement",
    name: "Announcement",
    component: Announcement,

  },
  {
    path: "/home/announcement/announcementdetail",
    name: "announcementDetails",
    component: announcementdetail,
  },
  {
    path : "/home/announcement/addannouncement",
    name: "addAnnouncement",
    component: AddAnnouncement,
  },
  {
    path: "/home/userList",
    name: "empDirectory",
    component: EmployeeDirectory,
  },
  {
    path : "/home/editemployee",
    name: "editEmployee",
    component: EditEmployees,
  },
  {
    path : "/home/employeedetails",
    name: "employeeDetails",
    component: EmployeeDetails,
  },
  {
    path: "/home/meeting",
    name: "meeting",
    component: MeetingCalendar,
  },
  {
    path: "/home/meeting/createmeeting",
    component: CreateMeetingCalendar,
    name: "newMeeting",
  },
  {
    path: "/home/meeting/view/:meetingId",
    component: MeetingDetails,
    name: "meetingDetails",
  },
  {
    path: "/home/meeting/view/editmeeting/:meetingId",
    component: EditMeeting,
    name: "editmeeting",
  },
  {
    path: "/home/userprofile",
    component: UserProfile,
    name: "profile",
  },
  {
    path: "/home/userprofile/userprofiledetails",
    component: userprofileDetails,
    name: "profileDetails",
  },
  {
    path: "/home/userprofile/changepassword",
    component: ChangePassword,
    name: "changePassword",
  },
  {
    path: "/home/task",
    component: TaskDashboard,
    name: "Tasks",
  },
  {
    path: "/home/task/createtask",
    component: CreateTask,
    name: "newtasks",
  },
  {
    path: "/home/task/edittask",
    component: EditTask,
    name: "editTask",
  },
  {
    path: "/home/task/details/:taskId",
    component: TaskDetail,
    name: "taskDetail",
  },
  {
    path: "/home/task/mytask",
    component: MyTask,
    name: "myTasks",
  },
  {
    path: "/home/attedance",
    component: ViewSmartAttendance,
    name: "attendance",
  },
  {
    path: "/home/shared",
    component: SharedFolder,
    name: "shareFolder",
  },
  {
    path: "/home/shared/newsharedfolder",
    component: NewSharedFolder,
    name: "newfolder",
  },
  {
    path: "/home/shared/public",
    component: SharePublicView,
    name: "public",
  },
  {
    path: "/home/shared/private",
    component: SharePrivateView,
    name: "private",
  },
  {
    path: "/home/document",
    component: SmartDocument,
    name: "smartDocument",
  },

  {
    path: "/home/document/newdocument",
    component: NewDocument,
    name: "newDoc",
  },
  {
    path: "/home/document/list/:status",
    component: ViewDocument,
    name: "viewDocument",
  },
  {
    path: "/home/document/signdocument",
    component: SignDocument,
    name: "signDocument",
  },
  {
    path: "/home/document/previewDoc/:docId",
    component: ReviewedDocument,
    name: "reviewDocument",
  },
  {
    path: "/home/mom",
    component: MOM,
    name: "mom",
  },
  {
    path: "/home/add_mom",
    component: AddMom,
    name: "addMom",
  },
  {
    path: "/home/add_mom/create_mom",
    component: CreateMom,
    name: "createMom",
  },
  {
    path: "/home/create_mom/work_flow",
    component: WorkFlow,
    name: "createWorkflow",
  },

  {
    path: "/home/mom/list/:status",
    component: ViewMom,
    name: "viewMom",
  },
  {
    path: "/home/viewmom/pdfmom",
    component: PdfMom,
    name: "pdfMom",
  },
  {
    path: "/home/viewmom/signmom",
    component: SignMom,
    name: "signMom",
  },
  {
    path: "/home/viewmom/reviewmom",
    component: ReviewMom,
    name: "reviewMom",
  },
  {
    path: "/home/speech",
    component: AINote,
    name: "AInotes",
  },
  {
    path: "/home/quickall",
    component: QuickAll,
    name: "Services",
  },
  {
    path: "/home/assets",
    component: Assets,
    name: "assets",
  },
  {
    path:"/home/assets/viewassets",
    component : viewassets,
    name: "viewAssets",
  },
  {
    path: "/home/assets/newasset",
    component: NewAsset,
    name: "newAssets",
  },
  {
    path: "/home/team",
    component: Group,
    name: "team",
  },
  {
    path: "/home/team/viewgroup",
    component: ViewGroup,
    name: "Group Info",
  },
  {
    path: "/home/team/viewgroup/viewteam",
    component: ViewTeam,
    name: "ViewTeam",
  },
  {
    path : "/home/team/viewgroup/editteam",
    component: EditTeam,
    name: "EditTeam",
  },
  {
    path: "/home/team/newgroup",
    component: NewGroup,
    name: "newTeam",
  },
  {
    path: "/home/smartService",
    component: SmartServiceDashboard,
    name: "smartService",
  },
  {
    path: "/home/smartService/leaverequest",
    component: LeaveRequest,
    name: "leaverequest",
  },
  {
    path: "/home/smartService/workhomerequest",
    component: WorkHomeRequest,
    name: "wfrRequest",
  },
  {
    path:"/home/smartService/viewsmartservice/editWFR",
    component: EditWFRRequest,
    name: "editRequest",
  },
  {
    path: "/home/smartService/viewsmartservice/edit",
    component: EditLeaveRequest,
    name: "leaveHistory",
  },
  {
    path: "/home/smartService/Sickleave",
    component: SickLeave,
    name: "SickLeave",
  },
  {
    path: "/home/smartService/details/:leaveId",
    component: ViewSmartService,
    name: "viewSmartService",
  },
  {
    path: "/home/project",
    component: ProjectDashboard,
    name: "projects",
  },

  {
    path: "/home/project/all/:projectId",
    component: AllProject,
    name: "allProject",
  },
  {
    path: "/home/project/allproject/viewproject",
    component: ViewProject,
    name: "viewProjects",
  },
  {
    path: "/home/project/allproject/viewproject/meetings",
    component: ProjectMeeting,
    name: "meeting",
  },
  {
    path: "/home/project/allproject/viewproject/tasks",
    component: ProjectTask,
    name: "tasks",
  },
  {
    path: "/home/project/allproject/viewproject/smartdocument",
    component: ProjectSmartDocument,
    name: "document",
  },
  {
    path: "/home/project/allproject/viewproject/allprojecttask",
    component: AllProjectTask,
    name: "Tasks",
  },
  {
    path: "/home/overallinprogresstask",
    component: OverAllInProgressTask,
    name: "Over All In Progress Task",
  },
  {
    path: "/home/overallinprogressproject",
    component: OverAllInProgressProject,
    name: "Over All In Progress Project",
  },

  {
    path: "/home/document/pdfdocument",
    component: PdfDocument,
    name: "document",
  },


  {
    path: "/home/aidoc",
    component: AiDocumentEngine,
    name: "aidocumentengine",
  },


  {
    path: "/home/document/reviewdocument/viewpdf",
    component: ViewPdf,
    name: "viewPdf",
  },
  {
    path: "/home/viewmom/reviewmom/viewpdfmom",
    component: ViewpdfMom,
    name: "viewPdfMom",
  },


  {
    path: "/home/links",
    component: LinksAndVideos,
    name: "linksandvideos",
  },
  {
    path: "/home/links/newLinks",
    component: NewLinksAndVides,
    name: "newlinkvideo",
  },

  {
    path: "/home/itsupportmanager",
    component: ITSupportManager,
    name: "ticketsDetails",
  },
  {
    path: "/home/itsupportmanager/viewtickets",
    component: ViewTickets,
    name: "viewTickets",
  },
  {
    path: "/home/itsupportmanager/addtickets",
    component: AddTickets_E,
    name: "addTickets",
  },
  {
    path: "/home/itsupportemployee",
    component: ITsupportemployee,
    name: "tickets",
  },
  {
    path: "/home/supportIT/view/:id",
    component: ItSupportView,
    name: "viewTickets",
  },

  {
    path: "/home/itsupportmanager/viewtickets/ViewbyId/Assignticket",
    component: AssignItTickets,
    name: "assigntickets",
  },

  {
    path: "/home/itsupportemployee/addtickets",
    component: AddTickets_E,
    name: "addTickets",
  },


  // {
  //   path: "/home/ceodashboard/ceoemployees/ceorequest/viewrequest",
  //   component: viewceosmartservice,
  //   name: "viewrequest"
  // },

  // ,,,,


  {
    path: "/home/notification",
    component: Notification,
    name: "notifications",
  },
  {
    path: "/home/itsupportmanager",
    component: ITSupportManager,
    name: "itSupport",
  },
  {
    path: "/home/chatbot",
    component: ChatBot,
    name: "chatBot",
  },
  // {
  //   path: "/home/chat",
  //   component: Chat,
  //   name: "Chat",
  // },
  // {
  //   path: "/home/chat/newchat",
  //   component: NewChat,
  //   name: "All Users",
  // },
  // {
  //   path: "/home/chat/newchat/chatpage",
  //   component: ChatPage,
  //   name: "User",
  // },

  {
    path: "/home/request",
    component: Request,
    name: "request",
  },
  {
    path: "/home/request/reqdetails/:reqId",
    component: ViewRequest,
    name: "viewRequest",
  },
  // /home/request/reqdetails/
  // {
  //   path: "/home/request/reqdetails/:reqId",
  //   component: ViewReqbyId,
  //   name: "viewRequest",
  // },
  {
    path: "/home/forgotclockin&out",
    component: ForgotClockinOut,
    name: "newrequest",
  },
  {
    path: "/home/timezonechange",
    component: TimeZoneChange,
    name: "timezonechange",
  },
  {
    path: "/home/Payroll",
    component: PayrollDashboard,
    name: "payrollDashboard",
  },
  {
    path: "/home/PayrollDetails",
    component: PayrollDetails,
    name: "payrollDetails",
  },
  {
    path: "/home/Bot",
    component: Bot,
    name: "BOT",
  },
  {
    path: "/home/Bot/BotHistory",
    component: BotHistory,
    name: "botHistory",
  },
  {
    path: "/home/ocr",
    component: Ocr,
    name: "ocrscan",
  },
  {
    path: "/home/holidays",
    component: Holiday,
    name: "holiday",
  },

  {
    path: "/home/viewholiday",
    component: ViewHoliday,
    name: "viewHoliday",
  },
  {
    path: "/home/scanner",
    component: AiPdfGenerator,
    name: "AIPDFGenerator",
  },
  {
     path: "/home/debugger",
    component: Debugger,
    name: "AIPDFGenerator",
  }
];

const token = window.localStorage.getItem("Mandoobee-token");;

let userInfo = null;
if (token) {
  try {
    const decoded = jwtDecode(token);
    userInfo = decoded;
  } catch (error) {
    console.error("Token is invalid:", error);
  }
} else {
  console.error("Token is missing");
}

var routes = coreRoutes;
if (userInfo) {
  if (userInfo.role === 0 || userInfo.role === 1) {
    routes = [
      ...coreRoutes,
      {
        path: "/home/project/createproject",
        component: CreateProject,
        name: "newproject",
      },
      {
        path: "/home/dashboard/ceoemployees/ceotasks",
        component: CeoTasks,
        name: "tasksDetails",
      },
      {
        path: "/home/dashboard",
        component: CeoDashboard,
        name: "dashboard",
      },
      {
        path: "/home/dashboard/ceouserlist",
        component: CeoUserlist,
        name: "users",
      },
      {
        path: "/home/dashboard/ceoemployees",
        component: CeoEmployees,
        name: "employees",
      },
      {
        path: "/home/dashboard/ceoemployees/ceomeetings",
        component: CeoMeetings,
        name: "meetingDetails",
      },
    
      {
        path: "/home/dashboard/ceoemployees/ceotasks/viewceotasks",
        component: ViewCeoTasks,
        name: "tasksDetails",
      },
      {
        path: "/home/dashboard/ceoemployees/ceodocuments",
        component: CeoDocuments,
        name: "viewDocuments",
      },
      {
        path: "/home/dashboard/attendancereport",
        component: AttendanceReport,
        name: "attendanceRep",
      },
      {
        path: "/home/project/allproject/viewproject/editprojects",
        component: EditProjects,
        name: "editProjects",
      },
      {
        path: "/home/holidays/addholiday",
        component: AddHoliday,
        name: "addholiday",
      },
      {
        path: "/home/dashboard/ceoemployees/ceoattendance",
        component: CeoAttendance,
        name: "attendance",
      },
      {
        path: "/home/dashboard/ceoemployees/ceorequest",
        component: CeoRequest,
        name: "requestDetails",
      },
      {
        path: "/home/userList/add",
        name: "createEmployee",
        component: CreateEmployee,
      },
    ];
  }
}

export default routes;
